import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { CrmContactService } from "@services/crmContact.service";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "crm-contacts",
	styleUrls: ["crmContacts.css"],
	templateUrl: "crmContacts.html"
})
export class CrmContactsAdminComponent {
	canExportGrid = false;
	deleteEnabled = true;
	editEnabled = true;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemType = "CRM Contact";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];

	constructor(private router: Router, private toastService: ToastService, private itemService: CrmContactService, private exportLogService: ExportLogService, private protectedGridService: ProtectedGridService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getItems();
		this.checkGridExportPermissions();
	}

	addNewItem() { this.router.navigate([`${this.itemUrl}/create`]); }

	checkGridExportPermissions() {
		this.protectedGridService.canExport("CrmContacts").subscribe((res: any) => { this.canExportGrid = res.response; });
	}

	deleteRow(e: any) {
		if (confirm("Are you sure you want to delete this contact?")) {
			this.itemService.deleteSingleById(e.row.data.id).subscribe(
				() => { this.toastService.success("Contact deleted!"); this.getItems(); },
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
		}
	}

	editRow(e: any) { this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]); }

	getItems() {
		this.gridLoading = true;
		this.itemService.getAll().subscribe(
			(res: any) => { this.items = res.response.items; this.gridLoading = false; },
			(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
		);
	}

	headerButtonClick(method: any) {
		// @ts-ignore
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "CrmContacts";
		this.exportLogService.logExport(logExport).subscribe();
	}

	viewRow(e: any) { this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]); }
}
